import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import { StyledBookingsDetails } from "./styles";
import TabsV2 from "@/common/elements/TabsV2";
import ArrestInformationDetails from "./ArrestInformationDetails";
import BookingInformationDetails from "./BookingInformationDetails";
import HouseTrack from "../InmateDetails/HouseTrack";
import PersonalInformationDetails from "./PersonalInformationDetails";
import Select from "@/common/elements/InputElements/Select";
import BookingsCharges from "./BookingsCharges";
import InmateInformation from "./InmateInformation";
import JailIncidentsDetails from "./JailIncidentsDetails";
import BoookingsReleaseInformation from "./BoookingsReleaseInformation";
import BookingsComments from "./BookingsComments";
import OfficerReportsDetails from "./OfficerReportsDetails";
import AppointmentLogDetails from "./AppointmentLogDetails";
import MedicalAuthorizationsDetails from "./MedicalAuthorizationsDetails";
import BookingsMovementRules from "./BookingsMovementRules";
import FolderFlags from "../FolderFlags";
import Property from "../InmateDetails/Property";
import VisitorLogDetails from "./VisitorLogDetails";
import ClassificationDetails from "./Classification";
import AssociatesDetails from "./AssociatesDetails";
import InmateMedicationsDetails from "./InmateMedicationsDetails";
import BillingDetails from "./BillingDetails";
import VictimNotificationDetails from "./VictimNotificationDetails";
import BookingHolds from "./BookingHolds";
import BookingQueueDetails from "./BookingQueueDetails";
import SpinLoader from "@/common/elements/SpinLoader";
import BookingAdministrativeInformation from "./BookingAdministrativeInformation";
import ScheduledEventsDetails from "./ScheduledEventsDetails";
import ReleaseQueueDetails from "./ReleaseQueueDetails";
import ScheduledBookingInformation from "./ScheduledBookingInformation";
import Signatures from "./Signatures";
import Docs from "../InmateDetails/Docs";
import MedicalInfo from "../InmateDetails/MedicalInfo";
import { StyledFlex, StyledGridCol, StyledGridRow } from "@/common/styles";
import Button from "@/common/elements/Button";
import AdditionalBookingInformation from "./AdditionalBookingINfo";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MedicalQuestionnaireList from "../InmateDetails/MedicalQuestionnaireList";
import CashAccountDetails from "@/components/cashAccountDetails/CashAccountDetails";
import { fetchAllSubmodules } from "@/apis/config/configApi";
import InmateHeader from "@/components/InmateHeader";
import { hasCheckSecurity, isNonEmptyVariable } from "@/util/common_function";
import {
  Arbitrary_Names,
  Entity_types,
  Permissions,
  Security_Types,
} from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import useDialog from "@/hooks/useDialog";
import {
  MODULES_LIST,
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";
import NoAccess from "./NoAccess";
import { setBookings, setBookingsFieldsEnabled } from "@/slices/bookingsSlice";
import HouseAndTracksForm from "../HouseandTracking/HouseAndTrackingForm";
import dayjs from "dayjs";
import _ from "lodash";
import { INMATE_DETAILS_MODE } from "../InmateDetails";
import {
  useBioExtraSync,
  useArrestReportsExtraSync,
  useInmatePropertyExtraSync,
  useInmateMedicalExtraSync,
} from "@/hooks/useExtraTableSync";
import AdditionalInmateMedicalInfo from "./AdditionalInmateMedicalInfo";

const BookingsDetails = forwardRef(
  (
    {
      currentModule,
      onNextClickTrigger,
      allFormRef,
      nextBtnRef,
      tabChangeRef,
      releaseInmate,
      takeProperty,
      releaseAllProperty,
      handleReBook,
      fromBookingStep = false,
      fromFolderDetails = false,
      isBQ = false,
      selectedGroup,
      setSelectedGroup,
      setCurrentTabKey,
      currentTabKey,
      nextBookingStep,
    },
    ref,
  ) => {
    const { bookings, bookingsFieldsEnabled, isScheduledBooking } = useSelector(
      (state) => state?.bookings,
    );

    // Loads bio[0].bioExtra / arrestReports[0].arrestReportsExtra /
    // inmateProperty[0].inmatePropertyExtra's real PK as soon as a booking
    // with a real id is open, rather than only when whichever tab happens to
    // render those fields first gets visited (Additional Personal/Booking
    // Information and the two Inmate Property tabs are all lazily-mounted;
    // Release Information reads/writes the same arrestReportsExtra row
    // without ever visiting that tab). See hooks/useExtraTableSync.js for
    // the full reasoning.
    useBioExtraSync();
    useArrestReportsExtraSync();
    useInmatePropertyExtraSync();
    useInmateMedicalExtraSync();

    const fullSearch = useSelector((state) => state.fullSearch);
    const [isReleaseAllProperty, setIsReleaseAllProperty] = useState(null);
    const { allSubModules } = useSelector((state) => state.config);
    const [localSubModules, setLocalSubModules] = useState([]);
    const [isInLoan, setIsInLoan] = useState(false);
    const [isHouseAndTrackVisible, setIsHouseAndTrackVisible] = useState(false);
    const [latestCompletedTracking, setLatestCompletedTracking] =
      useState(null);
    const [cancelTransportDefaults, setCancelTransportDefaults] =
      useState(null);
    // Assume each tab has fields until its own extra-table column-defs fetch
    // resolves — avoids a hide-then-show flicker of the tab in the common
    // case where the customer does have that table's extra fields
    // configured (see AdditionalBookingInformation / AdditionalInmateMedicalInfo).
    const [hasBookingExtraFields, setHasBookingExtraFields] = useState(true);
    const [hasInmateMedicalExtraFields, setHasInmateMedicalExtraFields] =
      useState(true);
    let showVictimNotification = hasCheckSecurity(
      Security_Types.functionality,
      Entity_types.arbitary,
      LABELS_CAPITAL.VIEW,
      Arbitrary_Names.HideVictimNotifications,
    );
    let inmatemedications = hasCheckSecurity(
      Security_Types.functionality,
      Entity_types.arbitary,
      LABELS_CAPITAL.MODIFY,
      Arbitrary_Names.ViewMedicalInfo,
    );
    let billing = hasCheckSecurity(
      Security_Types.functionality,
      Entity_types.arbitary,
      LABELS_CAPITAL.VIEW,
      Arbitrary_Names.divInmateBilling,
    );
    let scheduledeventsArbitary = hasCheckSecurity(
      Security_Types.functionality,
      Entity_types.arbitary,
      LABELS_CAPITAL.VIEW,
      Arbitrary_Names.divScheduledEvents,
    );
    let SignaturesArbitary = hasCheckSecurity(
      Security_Types.functionality,
      Entity_types.arbitary,
      LABELS_CAPITAL.VIEW,
      Arbitrary_Names.divSignatures,
    );
    const sectionItems = useMemo(
      () => [
        {
          id: "1",
          label: "Personal Information",
          key: "personal-information",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <PersonalInformationDetails
              allFormRef={allFormRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "2",
          label: "Arrest Information",
          key: "arrest-information",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <ArrestInformationDetails
              arrestbookFormRef={allFormRef?.arrestbookFormRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "3",
          label: "Booking Information",
          key: "booking-information",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BookingInformationDetails
              bookingInfoFormRef={allFormRef?.bookingInfoFormRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "4",
          label: "Scheduled Booking Information",
          key: "scheduled-booking-information",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <ScheduledBookingInformation
              scheduledBookingRef={allFormRef?.scheduledBookingRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "5",
          label: "Charges",
          key: "charges",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BookingsCharges
              bookingChargeRef={allFormRef?.bookingChargeRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "6",
          label: "Inmate Information",
          key: "inmate-information",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <InmateInformation
              inmateInfoRef={allFormRef?.inmateInfoRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        ...(scheduledeventsArbitary
          ? [
              {
                id: "7",
                label: "Scheduled Events",
                key: "scheduled-events",
                children: hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.VIEW,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report,
                ) ? (
                  <ScheduledEventsDetails
                    scheduledEventRef={allFormRef?.scheduledEventRef}
                    startingPoint="Bookings"
                  />
                ) : (
                  <NoAccess subModuleName={"arrest report"} />
                ),
              },
            ]
          : []),
        {
          id: "8",
          label: "Release Information",
          key: "release-information",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BoookingsReleaseInformation
              boookingsRelease={allFormRef?.boookingsRelease}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "9",
          label: "Comments",
          key: "comments",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BookingsComments
              bookingsCommentsRef={allFormRef?.bookingsCommentsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          label: "Folder Flags",
          key: "jacket-flags",
          id: "10",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <FolderFlags
              folderFlagsRef={allFormRef?.folderFlagsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "11",
          label: "Classification",
          key: "classification",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <ClassificationDetails
              classificationDetailsRef={allFormRef?.classificationDetailsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
          // disabled: true,
          // icon: <StopOutlined />,
        },
        {
          id: "12",
          label: "Movement Rules",
          key: "movement-rules",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BookingsMovementRules
              bookingsMovementRulesRef={allFormRef?.bookingsMovementRulesRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "13",
          label: "Housing and Tracking",
          key: "housing-tracking",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <HouseTrack
              houseFormRef={allFormRef?.houseFormRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
          // children: <HousingAndTracking houseFormRef={allFormRef?.houseFormRef} />,
        },
        {
          id: "14",
          label: "Associates",
          key: "associates",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <AssociatesDetails
              associatesDetailsRef={allFormRef?.associatesDetailsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
          // disabled: true,
          // icon: <StopOutlined />,
        },
        {
          id: "15",
          label: "Holds",
          key: "holds",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BookingHolds
              bookingHoldsRef={allFormRef?.bookingHoldsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "16",
          label: "Linked and Scanned Documents",
          key: "linked-scanned-documents",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <Docs
              docsRef={allFormRef?.docsRef}
              startingPoint="Bookings"
              parentKey={MODULES_LIST.BOOKINGS}
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        ...(SignaturesArbitary
          ? [
              {
                id: "17",
                label: "Signatures",
                key: "signatures",
                children: hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.VIEW,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report,
                ) ? (
                  <Signatures
                    signaturesRef={allFormRef?.signaturesRef}
                    startingPoint="Bookings"
                  />
                ) : (
                  <NoAccess subModuleName={"arrest report"} />
                ),
                // disabled: true,
                // icon: <StopOutlined />,
              },
            ]
          : []),
        ...(showVictimNotification
          ? [
              {
                id: "18",
                label: "Victim Notification",
                key: "victim-notification",
                children: hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.VIEW,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report,
                ) ? (
                  <VictimNotificationDetails
                    victimNotificationDetailsRef={
                      allFormRef?.victimNotificationDetailsRef
                    }
                    startingPoint="Bookings"
                  />
                ) : (
                  <NoAccess subModuleName={"arrest report"} />
                ),
              },
            ]
          : []),
        ...(billing
          ? [
              {
                id: "19",
                label: "Billing",
                key: "billing",
                children: hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.VIEW,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report,
                ) ? (
                  <BillingDetails
                    billingDetailsRef={allFormRef?.billingDetailsRef}
                    startingPoint="Bookings"
                  />
                ) : (
                  <NoAccess subModuleName={"arrest report"} />
                ),
                // disabled: true,
                // icon: <StopOutlined />,
              },
            ]
          : []),
        {
          id: "20",
          label: "Visitors",
          key: "visitors",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <VisitorLogDetails
              visitorLogDetailsRef={allFormRef?.VisitorLogDetailsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
          // disabled: true,
          // icon: <StopOutlined />,
        },
        {
          id: "21",
          label: "Jail Incidents",
          key: "jail-incidents",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <JailIncidentsDetails
              jailIncidentsDetailsRef={allFormRef?.jailIncidentsDetailsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
          // disabled: true,
          // icon: <StopOutlined />,
        },
        {
          id: "22",
          label: "Booking Queue",
          key: "booking-queue",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BookingQueueDetails
              bookingQueueDetailsRef={allFormRef?.bookingQueueDetailsRef}
              startingPoint="Bookings"
              forceCompleteStep={nextBookingStep?.forceCompleteStep}
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "23",
          label: "Release Queue",
          key: "release-queue",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <ReleaseQueueDetails
              releaseQueueDetailsRef={allFormRef?.releaseQueueDetailsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "24",
          label: "Medical Questionnaires",
          key: "medical-questionnaires",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Inmate_Medical,
          ) ? (
            <MedicalQuestionnaireList
              medicalRef={allFormRef?.medicalRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"medical"} />
          ),
          // disabled: true,
          // icon: <StopOutlined />,
        },
        ...(inmatemedications
          ? [
              {
                id: "25",
                label: "Inmate Medications",
                key: "inmate-medications",
                children: hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.VIEW,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Inmate_Medical,
                ) ? (
                  <InmateMedicationsDetails
                    inmateMedicationsDetailsRef={
                      allFormRef?.inmateMedicationsDetailsRef
                    }
                    startingPoint="Bookings"
                  />
                ) : (
                  <NoAccess subModuleName={"medical"} />
                ),
              },
              {
                id: "26",
                label: "Medical Authorizations",
                key: "medical-authorizations",
                children: hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.VIEW,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Inmate_Medical,
                ) ? (
                  <MedicalAuthorizationsDetails
                    medicalAuthorizationsDetailsRef={
                      allFormRef?.medicalAuthorizationsDetailsRef
                    }
                    startingPoint="Bookings"
                  />
                ) : (
                  <NoAccess subModuleName={"medical"} />
                ),
              },
              {
                id: "27",
                label: "Appointment Log",
                key: "appointment-log",
                children: hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.VIEW,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Inmate_Medical,
                ) ? (
                  <AppointmentLogDetails
                    appointmentLogDetailsRef={
                      allFormRef?.appointmentLogDetailsRef
                    }
                    startingPoint="Bookings"
                  />
                ) : (
                  <NoAccess subModuleName={"property"} />
                ),
              },
              ...(hasInmateMedicalExtraFields
                ? [
                    {
                      id: "27a",
                      label: "Additional Inmate Medical Info",
                      key: "additional-inmate-medical-info",
                      children: hasCheckSecurity(
                        Security_Types.functionality,
                        Entity_types.subModule,
                        LABELS_CAPITAL.VIEW,
                        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                        SUB_MODULES_LIST_WITH_ID.Inmate_Medical,
                      ) ? (
                        <AdditionalInmateMedicalInfo
                          onFieldsLoaded={setHasInmateMedicalExtraFields}
                        />
                      ) : (
                        <NoAccess subModuleName={"medical"} />
                      ),
                    },
                  ]
                : []),
            ]
          : []),
        {
          id: "28",
          label: "Property Taken From Inmate",
          key: "property-taken-inmate",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Inmate_Property,
          ) ? (
            <Property
              propertyRef={allFormRef?.propertyRef}
              propertyShow={true}
              isReleaseAllProperty={isReleaseAllProperty}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"property"} />
          ),
        },
        {
          id: "29",
          label: "Property List",
          key: "property-list",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Inmate_Property,
          ) ? (
            <Property
              propertyListRef={allFormRef?.propertyListRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"property"} />
          ),
        },
        {
          id: "30",
          label: "Officer Reports",
          key: "officer-reports",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Inmate_Officer_Reports,
          ) ? (
            <OfficerReportsDetails
              OfficerReportsDetailsRef={allFormRef?.OfficerReportsDetailsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"officer report"} />
          ),

          // disabled: true,
          // icon: <StopOutlined />,
        },
        {
          id: "31",
          label: "Administrative Information",
          key: "administrative-information",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BookingAdministrativeInformation
              bookingAdministrativeInformationRef={
                allFormRef?.bookingAdministrativeInformationRef
              }
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        ...(hasBookingExtraFields
          ? [
              {
                id: "32",
                label: "Additional Booking Information",
                key: "additional-booking-information",
                children: hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.VIEW,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report,
                ) ? (
                  <AdditionalBookingInformation
                    startingPoint="Bookings"
                    onFieldsLoaded={setHasBookingExtraFields}
                  />
                ) : (
                  <NoAccess subModuleName={"arrest report"} />
                ),
              },
            ]
          : []),
        {
          id: "33",
          label: "Cash Account",
          key: "cash-account",
          children: <CashAccountDetails startingPoint="Bookings" />,
        },
      ],
      [isReleaseAllProperty, hasBookingExtraFields, hasInmateMedicalExtraFields],
    );
    const { showDialog } = useDialog();
    const dispatch = useDispatch();
    const selectOptions = [
      {
        key: "arrest-report",
        value: "arrest-report",
        label: "Arrest Report",
        text: "Arrest_Report",
      },
      {
        key: "inmate-medical",
        value: "inmate-medical",
        label: "Inmate Medical",
        text: "Inmate_Medical",
      },
      {
        key: "inmate-cash-account",
        value: "inmate-cash-account",
        label: "Inmate Cash Account",
        text: "Inmate_Cash_Account",
      },
      {
        key: "inmate-property",
        value: "inmate-property",
        label: "Inmate Property",
        text: "Inmate_Property",
      },
      {
        key: "inmate-officer-reports",
        value: "inmate-officer-reports",
        label: "Inmate Officer Reports",
        text: "Inmate_Officer_Reports",
      },
    ];

    useEffect(() => {
      const filteredData = selectOptions?.filter(
        (op) =>
          allSubModules?.some(
            (sub) => sub?.subModuleName === op.label && sub?.enabled,
          ) &&
          hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID[op.text],
          ),
      );

      if (filteredData?.length) {
        setLocalSubModules(filteredData);
      }
    }, [allSubModules]);

    // Group mappings
    const groupMappings = {
      "arrest-report": [
        "personal-information",
        "arrest-information",
        "booking-information",
        "scheduled-booking-information",
        "charges",
        "inmate-information",
        "scheduled-events",
        "release-information",
        "comments",
        "jacket-flags",
        "classification",
        "movement-rules",
        "housing-tracking",
        "associates",
        "holds",
        "linked-scanned-documents",
        "signatures",
        "victim-notification",
        "billing",
        "visitors",
        "jail-incidents",
        "booking-queue",
        "release-queue",
        "administrative-information",
        "additional-booking-information",
      ],

      "inmate-medical": [
        "personal-information",
        "jacket-flags",
        "medical-questionnaires",
        "inmate-medications",
        "medical-authorizations",
        "appointment-log",
        "additional-inmate-medical-info",
        "jail-incidents",
        "booking-queue",
        "release-queue",
        "administrative-information",
      ],

      "inmate-cash-account": [
        "personal-information",
        "cash-account",
        "jail-incidents",
        "booking-queue",
        "release-queue",
        "administrative-information",
      ],

      "inmate-property": [
        "personal-information",
        "signatures",
        "property-taken-inmate",
        "property-list",
        "jail-incidents",
        "booking-queue",
        "release-queue",
        "administrative-information",
      ],

      "inmate-officer-reports": [
        "personal-information",
        "officer-reports",
        "jail-incidents",
        "booking-queue",
        "release-queue",
        "administrative-information",
      ],
    };
    useEffect(() => {
      const fromJacket = sessionStorage.getItem("from-jacket") === "true";
      if (fromBookingStep || fromJacket) {
        dispatch(setBookingsFieldsEnabled(true));
      } else if (bookings?.bookingId) {
        dispatch(setBookingsFieldsEnabled(false));
      }
    }, []);
    // State Variables
    const [isLoading, setIsLoading] = useState(false);
    const [tabsToDisplay, setTabsToDisplay] = useState([]);
    const [isReturn, setIsReturn] = useState(false);
    const [lastLoan, setLastLoan] = useState(null);
    const [lastCell, setLastCell] = useState(null);
    const [selectedRow, setSelectedRow] = useState();
    const [houseTrackCounter, setHouseTrackCounter] = useState(0);
    const [selectedIndex, setSelectedIndex] = useState();

    useEffect(() => {
      setSelectedIndex(selectedRow?.inmateTrackingID);
    }, [selectedRow]);

    // Handle Select Change
    const handleSelectChange = (value) => {
      setSelectedGroup(value);
      setTabsToDisplay(groupMappings[value] || []);
    };

    // Filter and Sort Tabs to Display
    // When Bookings is opened as a popup from the Booking Queue / Release
    // Queue pages, those two tabs are redundant with the page the user came
    // from, so hide them — unless the popup's destination step IS the
    // Booking Queue tab itself (the "Booking Complete" / "Remove from Queue"
    // steps land there and rely on it being rendered to auto-open their
    // completion modal).
    const hiddenWhenFromQueue = isBQ
      ? ["release-queue"].concat(
          nextBookingStep?.key === "booking-queue" ? [] : ["booking-queue"],
        )
      : [];
    const sectionTabItems = sectionItems
      .filter((tab) => {
        return tab?.key && tabsToDisplay?.includes(tab.key);
      })
      .filter((tab) => !hiddenWhenFromQueue.includes(tab.key))
      .sort((a, b) => {
        const indexA = tabsToDisplay?.indexOf(a.key) ?? -1;
        const indexB = tabsToDisplay?.indexOf(b.key) ?? -1;
        return indexA - indexB;
      });

    // Tab Change Handler
    const onTabChange = (value) => {
      setCurrentTabKey(value);
    };

    // Set Initial State Based on `currentModule`
    useEffect(() => {
      setIsLoading(true);
      if (currentModule && groupMappings[currentModule]) {
        setSelectedGroup(currentModule);

        setTabsToDisplay(groupMappings[currentModule]);
        setCurrentTabKey(groupMappings[currentModule][0] || null);
        setIsLoading(false);
      }
    }, [currentModule]);

    // Update Tabs When `selectedGroup` Changes
    useEffect(() => {
      setIsLoading(true);
      if (selectedGroup && groupMappings[selectedGroup]) {
        setTabsToDisplay(groupMappings[selectedGroup]);
        setCurrentTabKey(groupMappings[selectedGroup][0] || null);
        setIsLoading(false);
      }
    }, [selectedGroup]);

    const handleMoveInmate = () => {
      setCurrentTabKey("housing-tracking");
    };

    useEffect(() => {
      // isReleaseAllProperty starts null and only ever becomes true from
      // handleSetIsReleaseAllProperty/the "Release All Property" button click
      // (see those call sites) - but useEffect runs after every mount
      // regardless of whether its dependency "changed" from nothing, so
      // without this guard the tab jumped to "property-taken-inmate" on
      // every single mount, clobbering whatever the currentModule effect
      // above had just correctly set (e.g. "personal-information"). Normal
      // in-app navigation usually re-fires that effect again afterward
      // (currentModule/selectedGroup changing) and self-corrects, masking
      // this; a one-shot mount (e.g. viewing a linked booking from another
      // module, which never touches module again) has nothing to correct it.
      if (isReleaseAllProperty) {
        setCurrentTabKey("property-taken-inmate");
      }
    }, [isReleaseAllProperty]);

    useEffect(() => {
      // Mirrors ASP's GetMostRecentCompleteEntryWhereInmateIsExpectedBack
      // (BookingInmateMovementCommon.vbs:317-451) exactly: scan every
      // Complete/In Transit InmateTracking record and keep the one with the
      // latest Sorting_Date - a dedicated SQL virtual field that equals
      // Actual_Date_And_Time for Complete/In Transit records (confirmed via
      // RecordStructureBookings.asp's vfSortingComplete/vfSortingInTransit
      // definitions). That record wins only if it has an Expected Back set
      // and no Return Date yet.
      //
      // This used to be computed two different (both wrong) ways:
      // 1) bookings.arrestReports[0].currentLocation text-matched against
      //    "Loan"/"At Court" - a derived label that can lag behind reality
      //    (confirmed via live test: a successful return left it showing
      //    the prior Loan text).
      // 2) tracking[tracking.length - 1] (last array element = "most
      //    recent") - wrong whenever a movement is created as Pending
      //    earlier (lower inmateTrackingID) and completed later, out of ID
      //    order (confirmed via live test 2026-10-06: a Scheduled-then-
      //    Completed movement had a LOWER id but a LATER Actual time than a
      //    quick-return record saved after it).
      const tracking = bookings?.inmateTracking || [];
      const toMoment = (t) =>
        isNonEmptyVariable(t?.actualDate)
          ? dayjs(`${t.actualDate} ${t?.actualTime || "00:00"}`, "MM/DD/YYYY HH:mm")
          : null;

      let mostRecent = null;
      let maxSortingDate = null;
      tracking.forEach((t) => {
        if (t?.movementStatus !== "Complete" && t?.movementStatus !== "In Transit") return;
        const sortingDate = toMoment(t);
        if (!sortingDate?.isValid()) return;
        if (!maxSortingDate || sortingDate.valueOf() >= maxSortingDate.valueOf()) {
          mostRecent = t;
          maxSortingDate = sortingDate;
        }
      });

      const isOutstandingLoan =
        mostRecent?.inmateLocation === "Loan" &&
        isNonEmptyVariable(mostRecent?.expectedBackDate) &&
        !isNonEmptyVariable(mostRecent?.returnDate);
      setIsInLoan(isOutstandingLoan);
    }, [bookings]);

    useEffect(() => {
      let tracking = _.clone(bookings?.inmateTracking);
      if (isNonEmptyVariable(tracking)) {
        tracking.reverse();
        let loan = null;
        let cell = null;
        tracking.forEach((e, i) => {
          if (
            loan == null &&
            e.inmateLocation == "Loan" &&
            e.movementStatus == "Complete"
          ) {
            loan = e;
          }
          if (
            cell == null &&
            e.inmateLocation == "In Jail" &&
            e.movementStatus == "Complete"
          ) {
            cell = e;
          }
        });
        if (isNonEmptyVariable(loan)) {
          setLastLoan(loan);
        }
        if (isNonEmptyVariable(cell)) {
          setLastCell(cell);
        }
      }
    }, [bookings]);

    const inmateReturnAction = () => {
      setIsHouseAndTrackVisible(true);
      setIsReturn(true);
    };

    const handleSetIsReleaseAllProperty = () => {
      setIsReleaseAllProperty(true);
    };

    function handleSetSelectedGroup(group) {
      let curr = localSubModules.find((mod) => mod?.key == group);
      if (curr) {
        setSelectedGroup(group);
      } else {
        setSelectedGroup(null);
        if (!window.isDialogShown) {
          window.isDialogShown = true;

          showDialog("info", {
            title: "Warning",
            content: `${group} is disabled, enable it in config and try again.`,
            confirmButtonText: "Ok",
          });

          setTimeout(() => {
            window.isDialogShown = false;
          }, 1000);
        }
        return;
      }
    }
    useImperativeHandle(tabChangeRef, () => ({
      onTabChange: onTabChange,
      setSelectedGroup: handleSetSelectedGroup,
      setIsReleaseAllProperty: handleSetIsReleaseAllProperty,
    }));

    const allItemsDisposed =
      bookings?.inmateProperty?.[0]?.inmatePropertyItems?.every(
        (item) =>
          item.inventoryItems &&
          item.inventoryItems[0] &&
          item.inventoryItems[0].itemStatus === "Disposed",
      );

    const getRestrictForMoveReason = (content) => {
      return new Promise((resolve, reject) => {
        showDialog("confirm", {
          title: "Warning",
          content: content,
          onConfirm: () => {
            resolve(true);
          },
          onCancel: () => {
            resolve(false);
          },
        });
      });
    };

    const handleSaveHouseTrack = () => {
      allFormRef?.houseFormRef.current
        .validateFields()
        .then(async () => {
          const values = allFormRef?.houseFormRef.current.getFormValues();

          const isTransportAdded =
            (values.inmateLocation === "Perm Housing Change" ||
              values.inmateLocation === "Transport") &&
            values?.movementStatus === "Complete";

          if (!bookings?.jacketId && isTransportAdded) {
            showDialog("info", {
              title: "Warning",
              content:
                "You must save the Booking record at least once before you can Transport the inmate.",
              confirmButtonText: "Ok",
            });
            return;
          }

          // if (values?.moveReason === "Receive Inmate") {
          //   const content = `You should only enter a Reason for Movement of "Recieve Inmate" if you are recieving the inmate as the result of a Transport from another facility Are you recieving the inmate from another facility?`;
          //   const isMovementReason = await getRestrictForMoveReason(content);

          //   if (!isMovementReason) {
          //     houseFormRef.current.setFormValue("moveReason", "");
          //     return;
          //   }
          // }

          const data = {
            ...values,
            expectedBackDate: isNonEmptyVariable(values?.expectedBackDateTime)
              ? dayjs(values?.expectedBackDateTime)?.format("MM/DD/YYYY")
              : null,
            expectedBackTime: isNonEmptyVariable(values?.expectedBackDateTime)
              ? dayjs(values?.expectedBackDateTime)?.format("HH:mm")
              : null,
            returnDate: isNonEmptyVariable(values?.returnBackDateTime)
              ? dayjs(values?.returnBackDateTime)?.format("MM/DD/YYYY")
              : null,
            returnTime: isNonEmptyVariable(values?.returnBackDateTime)
              ? dayjs(values?.returnBackDateTime)?.format("HH:mm")
              : null,
            scheduledDate: isNonEmptyVariable(values?.scheduleDateTime)
              ? dayjs(values?.scheduleDateTime)?.format("MM/DD/YYYY")
              : null,
            scheduledTime: isNonEmptyVariable(values?.scheduleDateTime)
              ? dayjs(values?.scheduleDateTime)?.format("HH:mm")
              : null,
            actualDate: isNonEmptyVariable(values?.actualDateTime)
              ? dayjs(values?.actualDateTime)?.format("MM/DD/YYYY")
              : null,
            actualTime: isNonEmptyVariable(values?.actualDateTime)
              ? dayjs(values?.actualDateTime)?.format("HH:mm")
              : null,
          };

          if (!data?.enterBusiness) {
            data.businesses = null;
          }

          delete data?.returnBackDateTime;
          delete data?.expectedBackDateTime;
          delete data?.scheduleDateTime;
          delete data?.actualDateTime;

          // const detail = flagDetails[INMATE_FLAG_TYPE.IN_JAIL];

          const inmateTracking = bookings?.inmateTracking || [];

          const existingIndex = inmateTracking.findIndex(
            (item) => item.inmateTrackingID === selectedIndex,
          );

          let updatedTracking;

          if (existingIndex !== -1) {
            // Update existing item
            updatedTracking = inmateTracking.map((item, index) =>
              index === existingIndex ? { ...item, ...data } : item,
            );
          } else {
            // Add new item
            updatedTracking = [...inmateTracking, data];
          }

          dispatch(
            setBookings({
              inmateTracking: updatedTracking,
            }),
          );
          setIsHouseAndTrackVisible(false);

          setHouseTrackCounter((prev) => prev + 1);
          if (houseTrackCounter === 0 && isInLoan) {
            setTimeout(() => {
              // setIsHouseAndTrackVisible(true);
              setIsReturn(false);
              setIsInLoan(false);
            }, 100);
          }

          if (houseTrackCounter >= 1) {
            setHouseTrackCounter(0);
            setIsReturn(false);
            setIsInLoan(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    useEffect(() => {
      const inmateTracking = bookings?.inmateTracking;

      if (Array.isArray(inmateTracking) && inmateTracking.length > 0) {
        const relevantStatuses = ["Perm Housing Change", "In Jail"];

        const completedRecords = inmateTracking.filter(
          (t) =>
            isNonEmptyVariable(t) &&
            t?.movementStatus === "Complete" &&
            relevantStatuses.includes(t?.inmateLocation),
        );

        const latest =
          completedRecords.length > 0
            ? completedRecords.reduce((max, t) =>
                t.inmateTrackingID > max.inmateTrackingID ? t : max,
              )
            : null;

        setLatestCompletedTracking(latest);
      } else {
        setLatestCompletedTracking(null);
      }
    }, [bookings?.inmateTracking]);

    const isPermHousingChange =
      latestCompletedTracking?.inmateLocation === "Perm Housing Change";

    const handleCancelTransport = () => {
      const userLocal = JSON.parse(localStorage.getItem("userDetails"));
      const userAgency = userLocal?.staff?.organization?.[0]?.agency;

      const inmateTracking = bookings?.inmateTracking || [];

      const latestPermHousing = inmateTracking
        .filter(
          (t) =>
            isNonEmptyVariable(t) &&
            t?.inmateLocation === "Perm Housing Change" &&
            t?.movementStatus === "Complete",
        )
        .reduce(
          (max, t) => (t.inmateTrackingID > max.inmateTrackingID ? t : max),
          { inmateTrackingID: -Infinity },
        );

      const custodialAgency = bookings?.arrestReports?.[0]?.custodialAgency;

      if (!userAgency || !custodialAgency || userAgency !== custodialAgency) {
        showDialog("info", {
          title: "Warning",
          content: `Only the user from the ${custodialAgency} agency can cancel this transport`,
          confirmButtonText: "Ok",
        });
        return;
      }

      // if (isNonEmptyVariable(latestPermHousing?.inmateTrackingID)) {
      //   const updatedTracking = inmateTracking.map((t) =>
      //     t.inmateTrackingID === latestPermHousing.inmateTrackingID
      //       ? { ...t, movementStatus: "Cancelled" }
      //       : t
      //   );

      //   dispatch(setBookings({ inmateTracking: updatedTracking }));
      // }

      const destination = latestPermHousing?.transportDestination || "Unknown"; // ← pull from record

      setCancelTransportDefaults({
        inmateLocation: "In Jail",
        movementStatus: "Complete",
        actualDateTime: dayjs(),
        moveReason: "Transport Cancelled",
        comments: `Transport to ${destination} cancelled`, // ← use it here
      });

      setIsHouseAndTrackVisible(true);
    };

    const handleReceiveInmate = () => {
      const userLocal = JSON.parse(localStorage.getItem("userDetails"));
      const userAgency = userLocal?.staff?.organization?.[0]?.agency;

      const inmateTracking = bookings?.inmateTracking || [];

      const latestPermHousing = inmateTracking
        .filter(
          (t) =>
            isNonEmptyVariable(t) &&
            t?.inmateLocation === "Perm Housing Change" &&
            t?.movementStatus === "Complete",
        )
        .reduce(
          (max, t) => (t.inmateTrackingID > max.inmateTrackingID ? t : max),
          { inmateTrackingID: -Infinity },
        );

      const transportDestination = latestPermHousing?.transportDestination;

      if (
        !userAgency ||
        !transportDestination ||
        userAgency !== transportDestination
      ) {
        showDialog("info", {
          title: "Warning",
          content: `Only the user from the ${transportDestination} agency can receive this inmate`,
          confirmButtonText: "Ok",
        });
        return;
      }

      const custodialAgency = bookings?.arrestReports?.[0]?.custodialAgency;
      // Agency matches — open the form
      setCancelTransportDefaults({
        inmateLocation: "In Jail",
        movementStatus: "Complete",
        actualDateTime: dayjs(),
        moveReason: "Receive Inmate",
        comments: `Receiving inmate from ${custodialAgency}`,
      });
      setIsHouseAndTrackVisible(true);
    };

    return (
      <>
        <StyledBookingsDetails>
          <div className="action-bar">
            <StyledGridRow gutter={9} justify="space-between">
              <StyledGridCol>
                <StyledFlex gap="10px">
                  {isPermHousingChange ? (
                    // Latest completed record is Perm Housing Change → transport buttons only
                    <>
                      <Button
                        color="white"
                        onClick={handleReceiveInmate}
                        disabled={!bookingsFieldsEnabled}
                      >
                        Receive Inmate
                      </Button>
                      <Button
                        color="white"
                        onClick={handleCancelTransport}
                        disabled={!bookingsFieldsEnabled}
                      >
                        Cancel Transport
                      </Button>
                    </>
                  ) : isInLoan == false ? (
                    <>
                      {bookings?.inJail === true &&
                        hasCheckSecurity(
                          Security_Types.functionality,
                          Entity_types.arbitary,
                          LABELS_CAPITAL.VIEW,
                          Arbitrary_Names.DisplayReleaseButton,
                        ) &&
                        !fullSearch &&
                        selectedGroup !== "inmate-property" && (
                          <Button
                            color="white"
                            onClick={() => releaseInmate(localSubModules)}
                            disabled={!bookingsFieldsEnabled}
                          >
                            Release
                          </Button>
                        )}
                      {bookings?.inJail === false &&
                        hasCheckSecurity(
                          Security_Types.functionality,
                          Entity_types.arbitary,
                          LABELS_CAPITAL.VIEW,
                          Arbitrary_Names.DisplayRebookButton,
                        ) &&
                        !fullSearch &&
                        selectedGroup !== "inmate-property" && (
                          <Button
                            color="white"
                            onClick={handleReBook}
                            disabled={
                              !bookingsFieldsEnabled || !bookings?.bookingId
                            }
                          >
                            Rebook
                          </Button>
                        )}
                      {selectedGroup === "arrest-report" &&
                        bookings?.inJail === true &&
                        !fullSearch &&
                        !isScheduledBooking && (
                          <Button
                            color="white"
                            onClick={() => setCurrentTabKey("housing-tracking")}
                            disabled={!bookingsFieldsEnabled}
                          >
                            Move Inmate
                          </Button>
                        )}
                      {selectedGroup === "inmate-property" && (
                        <Button
                          color="white"
                          onClick={takeProperty}
                          disabled={!bookingsFieldsEnabled}
                        >
                          Take Property
                        </Button>
                      )}
                      {selectedGroup === "inmate-property" &&
                        bookings?.inmateProperty?.[0]?.inmatePropertyItems
                          ?.length > 0 &&
                        !allItemsDisposed && (
                          <Button
                            color="white"
                            onClick={() => {
                              releaseAllProperty();
                              setIsReleaseAllProperty(true);
                            }}
                            disabled={!bookingsFieldsEnabled}
                          >
                            Release All Property
                          </Button>
                        )}
                    </>
                  ) : (
                    <Button
                      color="white"
                      onClick={inmateReturnAction}
                      disabled={!bookingsFieldsEnabled}
                    >
                      Inmate Return
                    </Button>
                  )}

                  {/* <Button color="white" onClick={handleMoveInmate}>
                  Move Inmate
                </Button> */}
                </StyledFlex>
              </StyledGridCol>

              <StyledGridCol>
                <Select
                  value={selectedGroup}
                  allowClear={false}
                  options={localSubModules}
                  onChange={handleSelectChange}
                  style={{ width: "190px" }}
                  loading={false}
                />
              </StyledGridCol>
            </StyledGridRow>
          </div>
          <InmateHeader
            fromFolderDetails={fromFolderDetails}
            inmateMainTitle="New Booking"
          />
          <HouseAndTracksForm
            showDetailsPopup={isHouseAndTrackVisible}
            setShowDetailsPopup={setIsHouseAndTrackVisible}
            bookingsFieldsEnabled={bookingsFieldsEnabled}
            houseFormRef={allFormRef?.houseFormRef}
            isEdit={true}
            mode={INMATE_DETAILS_MODE.EDIT}
            handleSave={handleSaveHouseTrack}
            isReturn={isReturn}
            setIsReturn={setIsReturn}
            lastCell={lastCell}
            lastLoan={lastLoan}
            setLastCell={setLastCell}
            setLastLoan={setLastLoan}
            isInLoan={isInLoan}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            cancelTransportDefaults={cancelTransportDefaults}
            setCancelTransportDefaults={setCancelTransportDefaults}
            isCancelTransport={!!cancelTransportDefaults}
          />
          <SpinLoader spinning={isLoading} tip="loading">
            {/* Sections */}
            <TabsV2
              activeKey={currentTabKey}
              navButtonsColor="default"
              onChange={onTabChange}
              items={sectionTabItems}
              nextBtnRef={nextBtnRef}
              onNextClickTrigger={onNextClickTrigger}
            />
          </SpinLoader>
        </StyledBookingsDetails>
      </>
    );
  },
);

export default BookingsDetails;
